export default defineNuxtRouteMiddleware(async (to, from) => {
  const { status } = useAuth()
  const { link, links, init, isLoading } = useSetup()
  const { setLanguage, lang } = useLanguage()
  if(!Object.keys(links.value).length) {
    await init()
  }

  const _lang = to.path?.split('/')?.[1]
  if(_lang && _lang !== lang.value) {
    isLoading.value = true
    await setLanguage(_lang)
    await init()
    isLoading.value = false
  }

  const authPart = link('Login')?.split('/')?.[2]
  if(to.path.includes(authPart) && ![link('Login'), link('Registration'), link('RegistrationCompleted'), link('Loyalty'), link('LoyaltyTerms')].includes(to.path) && status.value !== 'authenticated') {
    return navigateTo(`${link('Login')}?r=1`)
  }
})